import { render, staticRenderFns } from "./CustomInnerPageMessage.vue?vue&type=template&id=c9cc61a0"
import script from "./CustomInnerPageMessage.vue?vue&type=script&lang=js"
export * from "./CustomInnerPageMessage.vue?vue&type=script&lang=js"
import style0 from "./CustomInnerPageMessage.vue?vue&type=style&index=0&id=c9cc61a0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports